function insertElementsByEventsResponse(events, target) {
  let fragment = document.createDocumentFragment();
  for (const event of events) {
    let template = document
      .getElementsByClassName("relation-events-template")[0]
      .cloneNode(true);
    // イベントURL
    let link = template.getElementsByTagName("a")[0];
    link.href = event.url;
    // タグ
    let tagGroup = template.getElementsByClassName("tag-group")[0];
    tagGroup.innerHTML = "";
    for (const tag of event.tags) {
      let span = document.createElement("span");
      span.classList.add("tag");
      span.textContent = tag;
      tagGroup.appendChild(span);
    }
    // 画像
    let thum = template.getElementsByClassName("thum")[0];
    thum.style = `background-image:url(${event.image_url})`;
    let inner = template.getElementsByClassName("inner")[0];
    inner.style = `background-image:url(${event.image_url})`;
    // タイトル
    let title = template.getElementsByClassName("title")[0];
    title.textContent = event.title;
    // カテゴリ
    let category = template.getElementsByClassName("category")[0];
    if (category) {
      const label = event.category_label || "";
      category.textContent = label;
      category.style.display = label ? "block" : "none";
    }
    // 日付
    let date = template.getElementsByClassName("date")[0];
    date.textContent = event.begin_date;
    // 時間
    let time = template.getElementsByClassName("time")[0];
    time.textContent = event.open_start;
    // ライブハウス名
    let caption = template.getElementsByClassName("caption")[0];
    caption.textContent = event.space_name;

    template.style = "display:block";
    fragment.appendChild(template);
  }
  const container = document.getElementById(target);
  container.appendChild(fragment);
}

function isPageEnd() {
  return page.current == page.total;
}

function relationEvents(page) {
  const url = new URL(location.href);
  const id = url.pathname.split("/").pop();

  fetch(`${settings.endpoint}/api/events/${id}/relation_artist_events?page=${page}`)
    .then((response) => {
      // ページ設定更新
      window.page.current = parseInt(response.headers.get("Current-Page"));
      window.page.total = parseInt(response.headers.get("Total-Pages"));
      return response.json();
    })
    .then((data) => {
      // dataの長さが0の場合は非表示
      if (data.length === 0) {
        document.getElementById("relation-lives-container").style.display = "none";
      }      
      insertElementsByEventsResponse(data, "relation-events");
    });
}

function relationGenreEvents(page) {
  const url = new URL(location.href);
  const id = url.pathname.split("/").pop();

  fetch(
    `${settings.endpoint}/api/events/${id}/relation_genre_events?page=${page}`
  )
    .then((response) => {
      // ページ設定更新
      window.page.current = parseInt(response.headers.get("Current-Page"));
      window.page.total = parseInt(response.headers.get("Total-Pages"));
      return response.json();
    })
    .then((data) => {
      // dataの長さが0の場合は非表示
      if (data.length === 0) {
        document.getElementById("relation-genre-lives-container").style.display = "none";
      }
      insertElementsByEventsResponse(data, "relation-genre-events");
    });
}


relationEvents(1);
relationGenreEvents(1);
